module.exports = __webpack_public_path__ + "img/campaign-stats.9044906f.svg";